<template>
	<div>
		<ul class="follow-list">
			<li v-for="(item, index) in listData" :key="index">
				<div class="clearfix">
					<div class="follow-img">
						<img class="poster-image" :src="item.followUser | imgUrl('headImage')" />
					</div>
					<div class="follow-info">
						<div class="follow-username">{{item.followUser.username}}</div>
						<div class="follow-fans">{{item.fansCount}}粉丝</div>
					</div>
					<div class="follow-btn">
						<span class="active" @click="selectReplay(index)">发私信</span>
						<span @click="cancelFollow(item.followUser.id, item.status, index)" v-if="mode_ === 1">
							{{item.status === 1 ? '互相关注' : '已关注'}}
						</span>
						<span @click="follow(item.followUser.id, item.status, index)" v-if="mode_ === 2">
							{{item.status === 1 ? '互相关注' : '关注'}}
						</span>
					</div>
				</div>
				<div class="replay-box clearfix" v-show="replayIndex === index">
					<textarea @input="changeReplay"></textarea>
					<button @click="sendMessage(item.followUser.id)">提交</button>
				</div>
			</li>
		</ul>
		<ss-no-data v-if="!finish && busy" text="数据加载中" />
		<ss-no-data v-else-if="finish && busy && listData.length === 0" mode="image" :text="this.mode_ === 1 ? '你还没有关注过任何人呢~' : (this.mode_ === 2 ? '还没有人关注你喔~' : '')" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				listData: [],
				replayIndex: -1,
				messageText: '',
				memeberId: ''
			}
		},
		props:{
			//1 正常查看看  ，2 我的圈子  3我的收藏
			mode: {
				type: [String, Number],
				default: 1
			},
			value: {
				type: Array,
				default: () => []
			},
			finish: {
				type: Boolean,
				default: false
			},
			busy: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			mode_() {
				return this.mode ? parseInt(this.mode) : 1;
			}
		},
		watch: {
			value: {
				handler(val) {
					this.listData = val.concat();
				},
				deep: true,
				immediate: true
			},
		},
		methods: {
			selectReplay(index) {
				this.replayIndex !== index && (this.messageText = '');
				this.replayIndex = this.replayIndex === index ? -1 : index;
			},
			changeReplay(e) {
				this.messageText = e.target.value;
			},
			async sendMessage(memeberId) {
				if(this.replayIndex === -1) return  ;
				if(!memeberId)  return this.$toast('数据错误，id不存在');
				if(!this.messageText) return this.$toast('发送内容不能为空');
				let res = await this.$http('sendMessage', {
					memeberId: [memeberId],
					content: this.messageText
				})
				if(res.code === 1){
					this.selectReplay(-1);
				}
			},
			async cancelFollow(id, followStatus, index) {
				let res = await this.$http('cancelFollow', {
					followUserId: id
				});
				if(res.code === 1){
					this.listData.splice(index, 1);
				}
			},
			async follow(id, followStatus, index) {
				let res = await this.$http(followStatus === 0 ? 'follow': 'cancelFollow', {
					followUserId: id
				});
				if(res.code === 1){
					this.$set(this.listData[index], 'status', followStatus === 0 ? 1 : 0);
				}
			},
		}
	}
</script>

<style lang="scss">
	
	.follow-list{
		.follow-btn{
			margin-top: 20px;
			float: right;
			span{
				cursor: pointer;
				display: inline-block;
				width: 80px;
				font-size: 16px;
				font-weight: 400;
				color: #B9B9B9;
				line-height: 18px;
				margin-left: 40px;
				&.active{
					color: #035FFE;
				}
			}
		}
		.follow-img{
			float: left;
			width: 50px;
			img{
				width: 50px;
				height: 50px;
				border-radius: 100%;
				display: block;
			}
		}
		.follow-info{
			padding: 10px 20px 0;
			width: 500px;
			float: left;
			.follow-username{
				font-size: 16px;
				font-weight: 400;
				color: #101010;
				line-height: 18px;
			}
			.follow-fans{
				font-size: 14px;
				font-weight: 400;
				color: #035FFE;
				line-height: 26px;
			}
		}
		li{
			padding: 30px;
			border-top: 1px solid #DDDDDD;
		}
	}
</style>
